<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSubmit">
    <v-text-field
      v-model="form.name"
      :rules="rules.name"
      :value="data.name"
      label="Название"
    />
    <custom-select
      :list="rolesList"
      item-text="name"
      item-value="id"
      multiple
      search
      search-label="Поиск роли"
      label="Роли"
      @change="onChange"
      @search="onSearch"
    />
    <div class="d-flex justify-end">
      <v-btn class="primary" @click="onSubmit">
        Сохранить
      </v-btn>
    </div>
  </v-form>
</template>

<script>
import CustomSelect from '@/components/ui/custom-select';

const createDefaultForm = () => ({
  name: '',
  roles: [],
});

const createDefaultRules = () => ({
  name: [v => !!v || 'Введите название группы'],
  roles: [v => v.length || 'Должна быть выбрана хотя бы одна роль'],
});

export default {
  name: 'role-group-form',
  components: { CustomSelect },
  props: {
    data: {
      type: Object,
      default: createDefaultForm,
    },
    roles: {
      type: Array,
      default: () => [],
    },
    isEdit: Boolean,
  },
  data: () => ({
    valid: true,
    rules: createDefaultRules(),
    form: createDefaultForm(),
    search: '',
  }),
  computed: {
    rolesList() {
      if (this.search.length === 0) return this.roles;

      return this.roles.filter(_ => _.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1);
    },
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form = {
          ...this.form,
          ...JSON.parse(JSON.stringify(value)),
        };
      },
    },
  },
  created() {
    this.form = {
      ...this.form,
      ...JSON.parse(JSON.stringify(this.data)),
    };
  },
  methods: {
    onChange(e) {
      this.form.roles = e;
    },
    onSearch(e) {
      this.search = e;
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$emit('submit', { form: this.form, isEdit: this.isEdit });
      }
    },
  },
};
</script>

<style scoped>

</style>
